import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CCol,
  CRow,
  CWidgetStatsC,
} from '@coreui/react-pro'
import React, { useCallback, useEffect, useState } from 'react'
import EmailQuotaService from 'src/service/EmailQuotaService'
import Table from './Table'
import { cilListRich, cilPeople, cilUserFollow } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import EmailAlertSentLog from './EmailAlertSentLog'

const SendAlertEmail = () => {
  const [users, setUsers] = useState([])
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState({})
  const fetchUsers = useCallback(async () => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await EmailQuotaService.getTransactions(
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setUsers(result.data)
    } catch (error) {
      console.error('Error fetching users:', error)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  return (
    <>
      <CAccordionBody>
        <EmailAlertSentLog
          users={users}
          setUsers={setUsers}
          fetchUsers={fetchUsers}
          setActivePage={setActivePage}
          setItemsPerPage={setItemsPerPage}
          setColumnFilter={setColumnFilter}
          setColumnSorter={setColumnSorter}
          itemsPerPage={itemsPerPage}
          activePage={activePage}
          columnFilter={columnFilter}
          columnSorter={columnSorter}
        />
      </CAccordionBody>
    </>
  )
}

export default SendAlertEmail
